module.exports = __webpack_public_path__ + "fonts/600-700-normal-cyrillic.4a1bf14.woff2";